
import API from "../../../app/api";

export const getCartCount = async (
  cartType,
  userId,
  customerId
) => {
  const response = await API.get(`/cart/${cartType}/count`, {
    params: {
      userId,
      customerId,
    },
  });

  return response.data;
};